import * as React from "react";
import { Tooltip as MantineTooltip } from "@mantine/core";
import { useTheme } from "styled-components";
import { COLOR_SCHEME_LIGHT } from "theme/constants";
const Tooltip = ({ ...props }) => {
  const theme = useTheme();
  const styles = () => ({
    tooltip: {
      backgroundColor: theme.colors.global.contentBackground,
      color: theme.colors.text.primary,
      fontWeight: 400,
      fontSize: theme.fonts.size.small,
      padding: `${theme.spacings.xs} ${theme.spacings.sm}`,
      borderRadius: "6px",
      boxShadow: `0 2px 8px rgb(0 0 0 / ${theme.mode === COLOR_SCHEME_LIGHT ? "10%" : "40%"})`
    }
  });
  return /* @__PURE__ */ React.createElement(
    MantineTooltip,
    {
      zIndex: "var(--mantine-z-index-max)",
      styles,
      events: { hover: true, focus: true, touch: false },
      ...props
    }
  );
};
export default Tooltip;
